<template>
  <div class="circle" catchtap="runAnimation">
    <div class="left" :style="{ backgroundColor: color }">
      <div
        class="left-child"
        :style="{
          transform: 'rotate(' + leftRotate + 'deg)',
          transition: 'all ' + aniTime / 1000 + 's liner'
        }"
      ></div>
    </div>
    <div class="right" :style="{ backgroundColor: color }">
      <div
        class="right-child"
        :style="{
          transform: 'rotate(' + rightRotate + 'deg)',
          transition: 'all ' + aniTime / 1000 + 's liner'
        }"
      ></div>
    </div>
    <div class="percentage">{{ data }}</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: String,
      default: '0%'
    },
    color: {
      type: String,
      default: '#838AAE'
    }
  },
  data() {
    return {
      leftRotate: 0,
      rightRotate: 0,
      aniTime: 500
    }
  },
  mounted() {
    this.runAnimation()
  },
  methods: {
    runAnimation() {
      let curRotate = parseFloat(this.data)
      if (curRotate >= 0) {
        let rightRotate = (curRotate / 100) * 360
        this.rightRotate = rightRotate > 180 ? 180 : rightRotate
      }
      if (curRotate >= 50) {
        let leftRotate = ((curRotate - 50) / 100) * 360
        leftRotate = leftRotate > 180 ? 180 : leftRotate
        setTimeout(() => {
          this.leftRotate = leftRotate
        }, this.aniTime)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.circle {
  width: 20vw;
  height: 20vw;
  box-sizing: border-box;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  background-color: #f1f1f1;
}
.left {
  overflow: hidden;
  width: 10vw;
  height: 20vw;
  left: 0;
  top: 0;
  position: absolute;
}
.left-child {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: right center;
  transform: rotate(0deg);
  border-radius: 10vw 0vw 0vw 10vw;
  background: #f1f1f1;
}
.right-child {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: left center;
  transform: rotate(0deg);
  border-radius: 0vw 10vw 10vw 0vw;
  background: #f1f1f1;
}
.right {
  overflow: hidden;
  width: 10vw;
  height: 20vw;
  position: absolute;
  right: 0;
  top: 0;
}
.percentage {
  z-index: 2;
  width: 17.33vw;
  height: 17.33vw;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  background-color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
